<script>
import { defineComponent } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import LineFunction from '@/helper/facade/LineFunction.js'
import { LineTokenModel } from '../model/LineTokenModel'
import { LineQueryModel } from '../model/LineQueryModel'
import Util from '@/helper/Utility'

export default defineComponent({
    setup() {
        const lineFunction = new LineFunction()
        let lineQueryModel = new LineQueryModel();
        lineQueryModel.loadCache();

        const route = useRoute()
        const router = useRouter()

        let liffId = route.query.liff_id;
        if (liffId) {
            lineFunction.setLiffId(liffId)
        }
        let routepath = route.params?.routepath;
        if (routepath) {
            lineQueryModel.setLinePath(routepath)
        }
        
        //#region methods
        const initLiff = () => {

            let query = genQueryParams();
            if (!query.includes("state") && !query.includes("code")) {
                saveCacheLineQuery(query);
            }
            
            liffId = lineFunction.getLiffId()
            
            lineFunction.init(liffId).then(() => {
                let currentUrl = window.location.href;
                if (lineFunction.isLogin()) {
                    if (lineFunction.isTokenExpire()) {
                        lineFunction.logout()
                        lineFunction.login(currentUrl)
                        return
                    }

                    let idToken = lineFunction.getIdToken()
                    if (idToken != null) {
                        saveCacheLineIdToken(idToken)
                        lineQueryModel.loadCache();
                        query = lineQueryModel.query;
                        routepath = lineQueryModel.path;
                        
                        
                        window.location.replace("/" + routepath + query);
                    } else {
                        router.replace({
                            path: '/error',
                            query: {
                                msg: 'Line token id null',
                            }
                        })
                    }
                } else {
                    lineFunction.login(currentUrl);
                }
            }).catch((err) => {
                console.log(err)
                router.replace({
                    path: '/error',
                    query: {
                        msg: 'Line liff error',
                    }
                })
            })
        }
        const genQueryParams = () => {
            let queryLiffState = getQueryLiffState();

            if (queryLiffState != null) {
                return queryLiffState;
            } else {
                let queryParams = route.query;
                let str = "";
                for (let i in queryParams) {
                str += `${i}=${queryParams[i]}&`;
                }
                return "?" + str;
            }
        }
        const getQueryLiffState = () => {
            let query = route.query["liff.state"];
            if (Util.isEmptyStr(query)) {
                return null;
            }
            return query;
        }
        const saveCacheLineIdToken = (lineIdToken) => {
            let lineTokenModel = new LineTokenModel();
            lineTokenModel.setLineIdToken(lineIdToken);
            lineTokenModel.saveCache();
        }

        const saveCacheLineQuery = (query) => {
            lineQueryModel.setLineQuery(query);
            lineQueryModel.saveCache();
        }
        //#endregion methods

        //#region init
        initLiff()
        //#endregion init

        return {

        }
    }
})
</script>
<template>
    <div>
        <div class="mt-5 text-center">
            กำลัง Login Line
        </div>
    </div>
</template>
